// 文章202数据信息
export default {
  id: 'huizhou_101',
  content: `2025 年《老年人能力评估师》职业技能鉴定考试
  ![1](https://cdn.keihong.tech/img/20250608224402486.png)

![2](https://cdn.keihong.tech/img/20250608235319635.png)`
}
